import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, gradients } from '../../styles/colors';

const HeroContainer = styled.section.attrs(() => ({
  id: 'home', 
}))`
  height: 100vh;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

const SlideContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${props => props.active ? 1 : 0};
  transition: opacity 1s ease-in-out;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${gradients.heroOverlay};
`;

const Content = styled.div`
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10%;
  color: ${colors.white};
`;

const Title = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 4.2rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  max-width: 900px;
  letter-spacing: 1.2px;
  color: #f5f3eb; /* Elegant ivory */

  /* one strong, visible shadow */
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.8);

  @media (max-width: 768px) {
    font-size: 2.6rem;
  }
`;


const Subtitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  margin-bottom: 5rem;
  max-width: 625px;
  letter-spacing: 0.75px;
  color: #f8f5f0;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  /* luxury frosted-glass look */
  display: inline-block; /* fit exactly to text */
  padding: 0.8rem 1.6rem; /* more breathing space */
  border-radius: 8px;

  background: rgba(255, 255, 255, 0.15); /* airy instead of black */
  backdrop-filter: blur(5px);

  @media (max-width: 768px) {
    font-size: 1.2rem;
    padding: 0.6rem 1.2rem;
  }
`;



const CTAContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

const Button = styled.a`
  padding: 1rem 2rem;
  border-radius: 4px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &.primary {
    background: ${colors.primary};
    color: ${colors.white};
    
    &:hover {
      background: ${colors.accent};
    }
  }
  
  &.secondary {
    background: transparent;
    color: ${colors.white};
    border: 2px solid ${colors.white};
    
    &:hover {
      background: ${colors.white};
      color: ${colors.primary};
    }
  }
`;

const SlideNav = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  z-index: 2;
`;

const SlideIndicator = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid ${colors.white};
  background: ${props => props.active ? colors.white : 'transparent'};
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: ${colors.white};
  }
`;

const Hero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const slides = [
        {
            image: '/images/1rooftop.jpg',
            alt: 'Codename Forresta Top View'
        },
        {
            image: '/images/2surroundings.jpg',
            alt: 'Lush Green Surroundings'
        },
        {
            image: '/images/3pool.jpg',
            alt: 'Infinity Edge Exterior Pool'
        },
        {
            image: '/images/4lobby.jpg',
            alt: 'Lluxurious double-heighted lobby'
        },
        {
            image: '/images/5hall.jpg',
            alt: 'Opulent Celebration Hall'
        },
        {
            image: '/images/6gym.jpg',
            alt: 'Decked out Gymnasium'
        }
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    return (
        <HeroContainer>
            {slides.map((slide, index) => (
                <SlideContainer
                    key={index}
                    active={index === currentSlide}
                    style={{ backgroundImage: `url(${slide.image})` }}
                    role="img"
                    aria-label={slide.alt}
                />
            ))}

            <Overlay />

            <Content>
                <Title>Experience Elevated Living at Codename Forresta, Mulund West</Title>
                <Subtitle>
                    Spacious 3, 4, & 5  Bedroom Residences
                    <br />
                    By Rudani Realty and Shreeji Buildcon Group
                    <br />
                    MahaRERA Regd. Number: P51800034630
                </Subtitle>

                <CTAContainer>
                    <Button href="#contact" className="primary">
                        Enquire Now
                    </Button>
                </CTAContainer>
            </Content>

            <SlideNav>
                {slides.map((_, index) => (
                    <SlideIndicator
                        key={index}
                        active={index === currentSlide}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </SlideNav>
        </HeroContainer>
    );
};

export default Hero; 